import { Flex, type FlexProps } from '@chakra-ui/react';
import { type ReactNode } from 'react';

type StatusCardTitleProps = FlexProps;

export function StatusCardTitle({
  children,
  ...props
}: StatusCardTitleProps): ReactNode {
  return (
    <Flex gap="2.5" alignItems="center" textStyle="h300" {...props}>
      {children}
    </Flex>
  );
}
